export const ContactType = Object.freeze({
  EMAIL: "email",
  CALL: "call",
  TEXT: "text",
  SNAIL_MAIL: "snailMail",
  CARRIER_PIGEON: "carrierPigeon",
});
